import { GlobalStyles } from '@mui/material';
import ReactJoyride from 'react-joyride';

export const CustomJoyride = ({ tourProps }) => {
  const { steps, runTour, currentStepIndex, restartTour, handleJoyrideCallback } = tourProps;
  return (
    <>
      {globalJoyrideOverrides}
      <ReactJoyride steps={steps} run={runTour} continuous scrollToFirstStep stepIndex={currentStepIndex} showProgress={true} callback={handleJoyrideCallback} showSkipButton styles={joyrideStyles} locale={{ last: 'End', skip: 'Skip', next: 'Next', back: 'Back', }} />
    </>
  );
};

const themeColors = { primary: '#2442AF', secondary: '#6E759F', success: '#57CA22', warning: '#FFA319', error: '#FF1943', info: '#33C2FF', black: '#223354', white: '#ffffff', primaryAlt: '#000C57' };

const joyrideStyles = {
  options: {
    zIndex: 10000,
    primaryColor: themeColors.info,
    textColor: themeColors.black,
    backgroundColor: themeColors.white,
    overlayColor: 'rgba(0, 0, 0, 0.5)',

    spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
    buttonNext: { backgroundColor: themeColors.primary, color: themeColors.white, },
    buttonBack: { color: themeColors.primary, },
    buttonSkip: { color: themeColors.primary, },
    beacon: { backgroundColor: themeColors.primary, },
  },
};

const globalJoyrideOverrides = (
  <GlobalStyles styles={{ '.react-joyride__tooltip button:focus-visible, .react-joyride__beacon:focus-visible': { outline: 'none !important', }, ".react-joyride__overlay": { height: "150% !important" } }} />
);

export default CustomJoyride;
